import { Injectable } from '@angular/core';
import { LOG_LEVEL, Purchases } from '@revenuecat/purchases-capacitor';
import { environment } from 'src/environments/environment';
import { AppuserService } from '../appuser/appuser.service';
import { AppUser } from 'src/app/models/appUser.model';
import { Platform } from '@ionic/angular';
import { AppSettingsService } from '../app-settings/app-settings.service';

@Injectable({
  providedIn: 'root'
})
export class RevenuecatService {

  constructor(
    private appUserService: AppuserService,
    private platform: Platform,
    private appSettingsService: AppSettingsService
  ) { }

  async configRevenueCat(appUser: AppUser) {
    let appUserID: string;
    let apiKey: string;

    if (this.platform.is("ios")) {
      apiKey = this.appSettingsService.iOSAPIKey;
    } else if (this.platform.is("android")) {
      apiKey = this.appSettingsService.androidAPIKey;
    } else {
      // if user does not have a RevenueCat AppUserID and is using web
      if (!appUser.revenuecatID) {
        await this.appUserService.addAppUserRevenueCatID();
      }
      return
    }

    if (!environment.production) {
      await Purchases.setLogLevel({ level: LOG_LEVEL.DEBUG });
    }

    // check to see if user has revenuecat id
    if (!appUser.revenuecatID) {
      // create and set revenuecat id
      appUserID = await this.appUserService.addAppUserRevenueCatID();
      if (appUserID) {
        // configure revenuecat with new appUserID
        await Purchases.configure({ apiKey: apiKey, appUserID: appUserID });
        await Purchases.setEmail({ email: appUser.email });
      }
    } else {
      // configure revenuecat with existing appUserID
      await Purchases.configure({ apiKey: apiKey, appUserID: appUser.revenuecatID });
    }
  }
}
